import React, { useState } from "react";

import withAnimation from "../../../hooks/withAnimation";

const ShareYourStorySection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    shortIntro: "",
    storyTitle: "",
    fullStory: "",
    timeline: [{ title: "", description: "" }],
    expertName: "",
    consent: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleTimelineChange = (index, field, value) => {
    const updatedTimeline = formData.timeline.map((milestone, i) =>
      i === index ? { ...milestone, [field]: value } : milestone
    );
    setFormData({ ...formData, timeline: updatedTimeline });
  };

  const addMilestone = () => {
    setFormData({
      ...formData,
      timeline: [...formData.timeline, { title: "", description: "" }],
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form data:", formData);
  };

  return (
    <div className="bg-background">
      {/* Hero Section */}
      <section
        className="relative bg-gradient-to-t from-gray-900 to-gray-800 text-white text-center py-48"
       
      >
        <div className="absolute inset-0">
          {/* <img
            src={bannerTestinomialDetailImage}
            alt="Share Your Story"
            className="w-full h-full object-cover object-[center-bottom] opacity-40" 
            
          /> */}
        </div>
        <div className="relative z-10">
          <h1 className="text-6xl font-extrabold">Share Your Story</h1>
          <p className="text-2xl mt-4">
            Inspire others by sharing your journey with us.
          </p>
        </div>
      </section>

      {/* Main Form Area */}
      <section className="relative container mx-auto py-24 px-6 lg:flex lg:items-start lg:justify-between space-y-10 lg:space-y-0 lg:space-x-12">
        {/* Form Section */}
        <div className="lg:w-1/2 bg-white p-12 rounded-3xl shadow-2xl relative z-10 transform transition hover:scale-105 duration-500 ease-in-out hover:shadow-3xl">
          <h2 className="text-5xl font-bold text-primary mb-8">
            Share Your Journey
          </h2>
          <form onSubmit={handleSubmit} className="space-y-8">
            {/* Full Name */}
            <div className="relative">
              <label
                htmlFor="name"
                className="block text-xl font-semibold text-primary"
              >
                Full Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full mt-3 px-5 py-4 border-2 border-gray-200 rounded-full focus:border-primary focus:ring-2 focus:ring-primary transition duration-200 shadow-md hover:shadow-lg"
                placeholder="Your Full Name"
              />
            </div>

            {/* Short Intro */}
            <div className="relative">
              <label
                htmlFor="shortIntro"
                className="block text-xl font-semibold text-primary"
              >
                Short Intro
              </label>
              <input
                type="text"
                id="shortIntro"
                name="shortIntro"
                value={formData.shortIntro}
                onChange={handleChange}
                className="w-full mt-3 px-5 py-4 border-2 border-gray-200 rounded-full focus:border-primary focus:ring-2 focus:ring-primary transition duration-200 shadow-md hover:shadow-lg"
                placeholder="Short Introduction"
              />
            </div>

            {/* Story Title */}
            <div className="relative">
              <label
                htmlFor="storyTitle"
                className="block text-xl font-semibold text-primary"
              >
                Story Title
              </label>
              <input
                type="text"
                id="storyTitle"
                name="storyTitle"
                value={formData.storyTitle}
                onChange={handleChange}
                className="w-full mt-3 px-5 py-4 border-2 border-gray-200 rounded-full focus:border-primary focus:ring-2 focus:ring-primary transition duration-200 shadow-md hover:shadow-lg"
                placeholder="Give Your Story a Title"
              />
            </div>

            {/* Full Story */}
            <div className="relative">
              <label
                htmlFor="fullStory"
                className="block text-xl font-semibold text-primary"
              >
                Full Story
              </label>
              <textarea
                id="fullStory"
                name="fullStory"
                value={formData.fullStory}
                onChange={handleChange}
                rows="6"
                className="w-full mt-3 px-5 py-4 border-2 border-gray-200 rounded-lg focus:border-primary focus:ring-2 focus:ring-primary transition duration-200 shadow-md hover:shadow-lg"
                placeholder="Share your full story..."
              ></textarea>
            </div>

            {/* Timeline */}
            <div className="relative">
              <label
                htmlFor="timeline"
                className="block text-xl font-semibold text-primary"
              >
                Recovery Timeline
              </label>
              {formData.timeline.map((milestone, index) => (
                <div key={index} className="mb-6">
                  <input
                    type="text"
                    value={milestone.title}
                    onChange={(e) =>
                      handleTimelineChange(index, "title", e.target.value)
                    }
                    className="w-full mt-3 px-5 py-4 border-2 border-gray-200 rounded-full focus:border-primary focus:ring-2 focus:ring-primary transition duration-200 shadow-md hover:shadow-lg"
                    placeholder={`Milestone Title ${index + 1}`}
                  />
                  <textarea
                    value={milestone.description}
                    onChange={(e) =>
                      handleTimelineChange(index, "description", e.target.value)
                    }
                    className="w-full mt-3 px-5 py-4 border-2 border-gray-200 rounded-lg focus:border-primary focus:ring-2 focus:ring-primary transition duration-200 shadow-md hover:shadow-lg"
                    placeholder={`Milestone Description ${index + 1}`}
                  />
                </div>
              ))}
              <button
                type="button"
                onClick={addMilestone}
                className="bg-primary text-white py-3 px-6 rounded-full font-semibold hover:bg-gradient-to-l transform hover:scale-105 transition duration-200 ease-in-out mt-4"
              >
                Add Milestone
              </button>
            </div>

            {/* Expert Name */}
            <div className="relative">
              <label
                htmlFor="expertName"
                className="block text-xl font-semibold text-primary"
              >
                Expert Name
              </label>
              <input
                type="text"
                id="expertName"
                name="expertName"
                value={formData.expertName}
                onChange={handleChange}
                className="w-full mt-3 px-5 py-4 border-2 border-gray-200 rounded-full focus:border-primary focus:ring-2 focus:ring-primary transition duration-200 shadow-md hover:shadow-lg"
                placeholder="Name of the Expert"
              />
            </div>

            {/* Consent Checkbox */}
            <div className="flex items-start mt-4">
              <input
                type="checkbox"
                id="consent"
                name="consent"
                checked={formData.consent}
                onChange={handleChange}
                className="form-checkbox h-6 w-6 text-primary mt-1 transition duration-200 ease-in-out"
              />
              <label htmlFor="consent" className="ml-3 text-sm text-gray-700">
                I consent to my story being shared on the platform.{" "}
                <a href="#" className="text-primary underline">
                  Privacy Policy
                </a>
              </label>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full bg-primary  text-white py-4 rounded-full font-semibold transition duration-200 transform hover:scale-105"
            >
              Submit Your Story
            </button>
          </form>
        </div>

        {/* Visual Elements */}
        <div className="lg:w-1/2 space-y-12 flex-col items-center justify-center">
          <div className="relative w-full h-auto rounded-3xl shadow-2xl bg-gray-200 overflow-hidden group transform transition-all hover:scale-105 duration-500 ease-in-out">
            {/* <img
              src={bannerTestinomialImage}
              alt="Share Your Story"
              className="w-full h-full object-cover transform group-hover:scale-110 transition duration-500 ease-in-out"
            /> */}
            <div className="absolute inset-0 bg-black opacity-40 group-hover:opacity-70 transition duration-500 ease-in-out"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-white z-10 px-10">
              <h2 className="text-4xl font-bold mb-4 transform transition duration-300 ease-in-out group-hover:scale-110">
                Your Journey Matters
              </h2>
              <p className="text-xl mb-6 transform transition duration-300 ease-in-out group-hover:text-gray-300">
                Help others by sharing your story.
              </p>
              <button className="bg-primary hover:bg-secondary text-white py-3 px-6 rounded-full font-semibold transition duration-300 ease-in-out transform hover:scale-110">
                Share Now
              </button>
            </div>
          </div>
          {/* Additional Visual Element */}
          <div className="relative w-full h-auto rounded-3xl shadow-2xl bg-gray-200 overflow-hidden group transform transition-all hover:scale-105 duration-500 ease-in-out">
            {/* <img
              src={bannerTestinomialDetailImage}
              alt="Share Your Story"
              className="w-full h-full object-cover transform group-hover:scale-110 transition duration-500 ease-in-out"
            /> */}
            <div className="absolute inset-0 bg-black opacity-40 group-hover:opacity-70 transition duration-500 ease-in-out"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-white z-10 px-10">
              <h2 className="text-4xl font-bold mb-4 transform transition duration-300 ease-in-out group-hover:scale-110">
                Inspire Others
              </h2>
              <p className="text-xl mb-6 transform transition duration-300 ease-in-out group-hover:text-gray-300">
                Share the impact of your journey.
              </p>
              <button className="bg-primary hover:bg-secondary text-white py-3 px-6 rounded-full font-semibold transition duration-300 ease-in-out transform hover:scale-110">
                Get Started
              </button>
            </div>
          </div>

          {/* Third Visual Element */}
          <div className="relative w-full h-auto rounded-3xl shadow-2xl bg-gray-200 overflow-hidden group transform transition-all hover:scale-105 duration-500 ease-in-out">
            {/* <img
              src={bannerTestinomialDetailImage}
              alt="Share Your Story"
              className="w-full h-full object-cover transform group-hover:scale-110 transition duration-500 ease-in-out"
            /> */}
            <div className="absolute inset-0 bg-black opacity-40 group-hover:opacity-70 transition duration-500 ease-in-out"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-white z-10 px-10">
              <h2 className="text-4xl font-bold mb-4 transform transition duration-300 ease-in-out group-hover:scale-110">
                Make a Difference
              </h2>
              <p className="text-xl mb-6 transform transition duration-300 ease-in-out group-hover:text-gray-300">
                Let your story inspire hope and courage.
              </p>
              <button className="bg-primary hover:bg-secondary text-white py-3 px-6 rounded-full font-semibold transition duration-300 ease-in-out transform hover:scale-110">
                Start Now
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Encouragement Section */}
      <section className="bg-gradient-to-r from-primary to-secondary py-12 text-center text-white">
        <h2 className="text-3xl font-bold">Why Sharing Helps</h2>
        <p className="text-lg mt-4 max-w-2xl mx-auto">
          Sharing your story is a powerful way to reflect, inspire, and connect.
          It helps you process your experiences and offers hope to others on
          similar journeys. Together, we create a supportive community.
        </p>
        <a
          href="#"
          className="mt-6 inline-block bg-white text-primary py-3 px-6 rounded-full font-semibold hover:bg-opacity-90 transition duration-200"
        >
          Learn More About the Benefits of Sharing
        </a>
      </section>
    </div>
  );
};

export default withAnimation(ShareYourStorySection);
